import React, { useContext } from "react";
import "./ExamCreatorSidebar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileChartPie,
  faUserDoctor,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faArrowDownWideShort,
  faArrowUpShortWide,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import MDSpinner from "react-md-spinner";
import { AnimatePresence, motion } from "framer-motion";
import {
  faBookOpen,
  faEarListen,
  faPencil,
  faKeynote,
} from "@fortawesome/pro-regular-svg-icons";
import { ExamCreatorContext } from "../../../Util/contexts/ExamCreatorContext";
import { AppContext } from "../../../Util/contexts/AppContext";

const CATEGORIES = [
  {
    name: "Listening",
    icon: faEarListen,
  },
  {
    name: "Reading",
    icon: faBookOpen,
  },
  {
    name: "Writing",
    icon: faPencil,
  },
  {
    name: "Speaking",
    icon: faKeynote,
  },
];

const CategoryOption = ({ onClick, isSelected, icon, name }) => {
  return (
    <div className="caseListSidebarCategoryWrapper" onClick={onClick}>
      <div className="checkboxContainer">
        {isSelected && (
          <FontAwesomeIcon icon={faCheck} className="checkboxCheck" />
        )}
      </div>
      <FontAwesomeIcon icon={icon} className="caseListSidebarCategoryIcon" />
      <p className="caseListSidebarText">{name}</p>
    </div>
  );
};

const ExamCreatorSidebar = (props) => {
  const {
    sortBy,
    setSortBy,
    isCaseListAscending,
    setIsCaseListAscending,
    isHideCompletedChecked,
    setIsHideCompletedChecked,
    isHideIncompleteChecked,
    setIsHideIncompleteChecked,
    searchTerm,
    setSearchTerm,
    selectedCategories,
    setSelectedCategories,
    examListView,
    setExamListView,
    setIsMobileDrawerOpen,
  } = useContext(ExamCreatorContext);

  const { userData } = useContext(AppContext);

  const handleToggleCategory = (category) => {
    const newSelectedCategories = selectedCategories.includes(category)
      ? selectedCategories.filter((cat) => cat !== category)
      : [...selectedCategories, category];

    setSelectedCategories(newSelectedCategories);
  };

  const handleToggleExamType = () => {
    if (examListView === "Exam Sections") {
      setExamListView("Custom Exams");
    } else {
      setExamListView("Exam Sections");
    }
  };

  return (
    <div className="caseListSidebar">
      {userData.Profession === "" ? (
        <div className="caseListSidebarContentWrapper">
          <div className="caseListLogoContainer">
            {/* <img className='caseListLogo' alt='CCS Cases Logo' src={Logo}/> */}
            <h1 className="caseListLogoText">
              OCC<span className="caseListLogoTextNormal">English</span>
            </h1>
            <button
              className="caseListDrawerCloseButton"
              onClick={() => setIsMobileDrawerOpen(false)}
            />
          </div>
        </div>
      ) : (
        <div className="caseListSidebarContentWrapper">
          <div className="caseListLogoContainer">
            {/* <img className='caseListLogo' alt='CCS Cases Logo' src={Logo}/> */}
            <h1 className="caseListLogoText">
              OCC<span className="caseListLogoTextNormal">English</span>
            </h1>
            <button
              className="caseListDrawerCloseButton"
              onClick={() => setIsMobileDrawerOpen(false)}
            />
          </div>
          {props.showSubscriptionEndWarning ? (
            <p className="subscriptionEndWarningText">
              Your subscription ends in {props.subscriptionDaysRemaining}{" "}
              {props.subscriptionDaysRemaining === 1 ? "Day" : "Days"}.
            </p>
          ) : null}
          <div className="caseListMobileNavButtonContainer">
            <button
              className="caseListMobileNavButton"
              onClick={() => props.handlePageChange("accountSettings")}
            >
              <FontAwesomeIcon
                icon={faUserDoctor}
                className="caseListHeaderButtonIcon"
              />
              My Account
            </button>
          </div>
          <div className="caseListDropdownWrapper dropdownWithButton">
            <label className="standardLabel caseListSidebarLabel">
              Sort By
            </label>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="caseListDropdown"
            >
              <option value="CaseNumber">Exam Number</option>
              <option value="CompletionDate">Completion Date</option>
              <option value="ReviewLater">Review Later</option>
              <option value="AverageGrade">Average Grade</option>
              <option value="CaseTitle">Exam Title</option>
            </select>
            <button
              className="caseListSortDirectionButton"
              onClick={() => setIsCaseListAscending(!isCaseListAscending)}
            >
              <FontAwesomeIcon
                icon={
                  isCaseListAscending
                    ? faArrowUpShortWide
                    : faArrowDownWideShort
                }
                className="caseListSortDirectionIcon"
              />
            </button>
          </div>
          <div
            className="caseListDropdownWrapper"
            style={{ marginTop: "10px" }}
          >
            <label className="standardLabel caseListSidebarLabel">Search</label>
            <input
              className="caseListSearchInput"
              initial-scale="1"
              maximum-scale="1"
              placeholder="Ex: Listening"
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div
            className="caseListDropdownWrapper"
            style={{ marginTop: "10px" }}
          >
            <label className="standardLabel caseListSidebarLabel">
              Exam Style
            </label>
            <div className="caseListStyleToggle">
              <button
                className={`caseListStyleToggleOption ${
                  examListView === "Premade Exams"
                    ? "caseListStyleOptionSelected"
                    : ""
                }`}
                onClick={() => setExamListView("Premade Exams")}
              >
                Premade
              </button>
              <button
                className={`caseListStyleToggleOption ${
                  examListView === "Premade Exams"
                    ? ""
                    : "caseListStyleOptionSelected"
                }`}
                onClick={() => setExamListView("Exam Sections")}
              >
                Custom
              </button>
            </div>
          </div>
          <AnimatePresence mode="wait">
            {examListView !== "Premade Exams" && (
              <motion.div
                key="caseListSidebarControlsWrapper"
                initial={
                  props.AnimationsDisabled
                    ? false
                    : { opacity: 0, transform: "scale(0.9)" }
                }
                animate={
                  props.AnimationsDisabled
                    ? false
                    : { opacity: 1, transform: "scale(1)" }
                }
                exit={
                  props.AnimationsDisabled
                    ? false
                    : { opacity: 0, transform: "scale(0.9)" }
                }
                transition={{ duration: 0.25 }}
              >
                <button
                  className="caseListMyExamsViewButton"
                  onClick={handleToggleExamType}
                >
                  {examListView === "Custom Exams"
                    ? "Create a New Exam"
                    : "View My Custom Exams"}
                </button>
                <AnimatePresence mode="wait">
                  {examListView === "Exam Sections" && (
                    <motion.div
                      key="caseListSidebarCategoriesWrapper"
                      initial={
                        props.AnimationsDisabled
                          ? false
                          : { opacity: 0, transform: "scale(0.9)" }
                      }
                      animate={
                        props.AnimationsDisabled
                          ? false
                          : { opacity: 1, transform: "scale(1)" }
                      }
                      exit={
                        props.AnimationsDisabled
                          ? false
                          : { opacity: 0, transform: "scale(0.9)" }
                      }
                      transition={{ duration: 0.25 }}
                    >
                      <h2 className="caseListSidebarHeader">Categories</h2>
                      {CATEGORIES.map((category) => (
                        <CategoryOption
                          onClick={() => handleToggleCategory(category.name)}
                          isSelected={selectedCategories.includes(
                            category.name
                          )}
                          icon={category.icon}
                          name={category.name}
                          key={"Sidebar Category - " + category.name}
                        />
                      ))}
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            )}
          </AnimatePresence>
          <div className="caseListSidebarSectionBreak" />
          <h2 className="caseListSidebarHeader">Other</h2>
          <div
            className="caseListSidebarTagWrapper"
            onClick={() => setIsHideCompletedChecked(!isHideCompletedChecked)}
          >
            <div className="checkboxContainer">
              {isHideCompletedChecked && (
                <FontAwesomeIcon icon={faCheck} className="checkboxCheck" />
              )}
            </div>
            <p className="caseListSidebarText">Hide Completed</p>
          </div>
          <div
            className="caseListSidebarTagWrapper"
            onClick={() => setIsHideIncompleteChecked(!isHideIncompleteChecked)}
          >
            <div className="checkboxContainer">
              {isHideIncompleteChecked && (
                <FontAwesomeIcon icon={faCheck} className="checkboxCheck" />
              )}
            </div>
            <p className="caseListSidebarText">Hide Incomplete</p>
          </div>
          <label
            className="standardLabel caseListSidebarLabel"
            htmlFor="caseListAccentDropdown"
            style={{ marginTop: "8px" }}
          >
            Accent
          </label>
          <select
            value={props.accentSelected}
            onChange={props.handleSelectAccent}
            className="caseListDropdown"
            id="caseListAccentDropdown"
          >
            <option value="Random">Random</option>
            <option value="American">American</option>
            <option value="Australian">Australian</option>
            <option value="British">British</option>
            <option value="Irish">Irish</option>
          </select>
        </div>
      )}
    </div>
  );
};

export default ExamCreatorSidebar;
